import React, { memo } from 'react'
import ResultsSectionContainer from 'redux/containers/components/search/results-item/ResultsSectionContainer'
import { isEqual } from 'libraries/lodash'

const checkPropsAreEqual = (prevProps, nextProps) => (
  isEqual(nextProps.results, prevProps.results) && isEqual(nextProps.truncated, prevProps.truncated)
)

const Results = memo(({ results, truncated = false }) => (
  <ResultsSectionContainer {...{ results, truncated }} />
), checkPropsAreEqual)

export default Results
